export default __webpack_public_path__ + "static/media/homepage.621e6264.mp4";